import { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display/Loader";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { NotificationsUpdateModalInner } from "./NotificationsUpdateModalInner";
import { useNotificationsUpdateModalDataQuery } from "./hooks/__generated__/useNotificationsUpdateModalDataQuery.graphql";
import { NotificationsUpdateModalInnerQueryString } from "./hooks/useNotificationsUpdateModalData";

type NotificationsUpdateModalQueryWrapperProps = {
  onClose: () => void;
  showGuide?: boolean;
  onRequestVerification?: (mode: "email" | "phone") => void;
  onSaveSuccess?: () => void;
};

export const NotificationsUpdateModalQueryWrapper = ({
  onClose,
  showGuide,
  onRequestVerification,
  onSaveSuccess,
}: NotificationsUpdateModalQueryWrapperProps) => {
  const [queryRef, loadQuery] =
    useQueryLoader<useNotificationsUpdateModalDataQuery>(
      NotificationsUpdateModalInnerQueryString
    );

  useEffect(() => {
    loadQuery({}, { fetchPolicy: "network-only" });
  }, [loadQuery]);

  return (
    <Suspense
      fallback={
        <Box flex={1} position="relative">
          <Loader />
        </Box>
      }
    >
      {queryRef ? (
        <NotificationsUpdateModalInner
          onClose={onClose}
          queryRef={queryRef}
          onRequestVerification={onRequestVerification}
          showGuide={showGuide}
          onSaveSuccess={onSaveSuccess}
        />
      ) : null}
    </Suspense>
  );
};
